import IconYoutube from './utils/social_icons/IconYoutube';
import IconInstagram from './utils/social_icons/IconInstagram';

const SocialIconGroup = () => {
    return (
        <div className="flex mt-6 -mx-2 justify-center">

            <a href="http://www.youtube.com/cometmeted"
                className="mx-2 transition-colors duration-300 text-gray-300 hover:text-blue-400"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube">
                <IconYoutube size={16} />
            </a>

            <a href="https://www.instagram.com/cometmeted/"
                className="mx-2 transition-colors duration-300 text-gray-300 hover:text-blue-400"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram">
                <IconInstagram size={16} />
            </a>
        </div>
    );
};

export default SocialIconGroup;